const eventsLogHistory = new Map([
  ['login', 'Inicio de sesión'],
  ['logout', 'Cierre de sesión']
])

export {eventsLogHistory}



// WEBPACK FOOTER //
// ./src/utils/eventsLogHistory.js